import React from 'react';
import { Button } from '@gerdau/hefesto';
import { TableMenu } from '@gerdau/hefesto-mais-web';

import { CustomTable, ExternalLink, TableContainer } from './styles';
import { ProductInfoParagraph, ProductInfoTitle } from '../styles';

interface ProductTechDetailsTableProps {
  productText: JSX.Element[] | JSX.Element | string;
  table: JSX.Element[] | JSX.Element | string;
}

export const ProductTechDetailsTable = ({
  productText,
  table
}: ProductTechDetailsTableProps) => {
  return (
    <TableContainer>
      <ProductInfoTitle>Especificações técnicas</ProductInfoTitle>
      <ProductInfoParagraph>{productText}</ProductInfoParagraph>
      <TableMenu
        rightComponents={
          <ExternalLink
            href="https://mais.gerdau.com.br/catalogos-e-manuais/"
            target="_blank"
          >
            <Button variant="secondary" name={'Btn-redirect-catalog'}>
              Abrir catálogos e manuais
            </Button>
          </ExternalLink>
        }
      />
      <CustomTable>{table}</CustomTable>
    </TableContainer>
  );
};
